export const empty_option = {
  id: "none__empty__option",
  value: "None",
  label: "Assign to member",
};
